import styled from 'styled-components';

export const StyledOverview = styled.div`
  ul {
    li {
      margin-bottom: 16px;
      a {
        vertical-align: middle;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        svg {
          path {
            fill: #2552f3;
          }
        }
      }
    }
  }
`;
